import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-doc-select-item',
  templateUrl: './doc-item.component.html',
  styleUrls: ['./doc-item.component.less'],
  standalone: false
})
export class DocItemComponent {
  @Input() code = '';
  @Input() currency = ' ';
  @Input() amount = 0;
  @Input() company = '';
  @Input() date = new Date();

  constructor() {}
}
